import classNames from 'classnames';
import * as React from 'react';

export interface ProgressBar {
  children: JSX.Element | JSX.Element[];
}

export const Progression = ({ children }: ProgressBar): JSX.Element => {
  return <div className="relative w-full">{children}</div>;
};

export interface ProgressTextProps {
  text: string;
  className: string;
  style: React.CSSProperties;
}

export const ProgressText = ({ text, className, style }: ProgressTextProps) => {
  return (
    <div
      className={classNames({
        'absolute w-full text-right': true,
        [className || '']: !!className,
      })}
      style={{ transform: 'translateX(-45%)', marginTop: '-25px', ...style }}
    >
      {text}
    </div>
  );
};

export interface ProgressBufferTextProps {
  className?: string;
  style?: React.CSSProperties;
  text: string;
}

export const ProgressBufferText = ({ className, style, text }: ProgressBufferTextProps) => {
  return (
    <div
      className={classNames({
        'absolute w-full text-right': true,
        [className || '']: !!className,
      })}
      style={{ transform: 'translateX(-20%)', marginTop: '-25px', ...style }}
    >
      {text}
    </div>
  );
};

export interface ProgressBarProps {
  className?: string;
  valueClassName?: string;
  value: number;
  valueStyle?: React.CSSProperties;
  children?: JSX.Element;
  progressedChildren?: JSX.Element | JSX.Element[];
  height?: number;
  barProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
  progressedProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}

export const ProgressBar = ({
  className,
  valueClassName,
  value,
  valueStyle,
  children,
  height = 4,
  barProps,
  progressedProps,
  progressedChildren,
}: ProgressBarProps) => {
  return (
    <div
      className={classNames({
        [`relative overflow-hidden rounded-full h-${height}`]: true,
        [className || '']: !!className,
        'bg-blue-100': !className,
      })}
      {...barProps}
    >
      <div className="w-full h-full absolute" />
      <div
        className={classNames({
          'absolute top-0 left-0 w-full bottom-0 z-10 rounded-full': true,
          [valueClassName || '']: !!valueClassName,
          'bg-blue-500': !valueClassName,
        })}
        style={{
          transform: `translateX(-${100 - value}%)`,
          transition: 'transform 0.5s linear',
          ...valueStyle,
        }}
        {...progressedProps}
      >
        {progressedChildren}
      </div>
      {children}
    </div>
  );
};

export interface ProgressBufferBarProps {
  value: number;
  className?: string;
  style?: React.CSSProperties;
}

export const ProgressBufferBar = ({ value, className, style }: ProgressBufferBarProps) => {
  return (
    <div
      style={{
        transform: `translateX(-${100 - value}%)`,
        transition: 'transform 0.5s linear',
        ...style,
      }}
      className={classNames({
        'top-0 left-0 w-full bottom-0 absolute rounded-full': true,
        [className || '']: !!className,
        'bg-blue-300': !className,
      })}
    />
  );
};

export const Progress = {
  Wrapper: Progression,
  Text: ProgressText,
  BufferText: ProgressBufferText,
  Bar: ProgressBar,
  BufferBar: ProgressBufferBar,
};
